/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/css';

const wrapper = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 3px 3px 0 0;
  border: 1px solid #efefef;
  border-bottom: none;
  padding: 24px 24px 0;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const balanceData = css``;

const balanceDataHeader = css``;

const balanceDataBalance = css`
  font-weight: bold !important;
  font-size: 1.75rem !important;
  color: #006bf8 !important;
  span {
    color: grey;
  }
`;

const balanceDataBalanceError = css`
  font-weight: bold !important;
  color: #006bf8 !important;
`;

const actionsSection = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 10px;

  @media (max-width: 768px) {
    align-items: center;
    justify-content: center;
    margin-top: 1rem;

    button {
      width: 100%;
    }
  }
`;

const walletsDataContainer = css`
  border-radius: 0 0 3px 3px;
  background-color: #fff;
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #efefef;
  border-top: none;
`;

const stepsForm = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const rows = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

const swipeButton = css`
  border: 2px solid #006bf8 !important;
  color: #006bf8 !important;
  border-radius: 50% !important;
  display: flex !important;
  width: 40px;
  height: 40px;
`;

const confirmCheckWrapper = css`
  margin: 1rem auto;
  background: #4db6ac;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const confirmRow = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.5rem;

  p {
    font-weight: bold;
  }
`;

const tabsWrapper = css({
  display: 'flex',
  width: '100%',
  padding: '12px 0',
});

export const WalletsStyles = {
  wrapper,
  balanceData,
  balanceDataHeader,
  balanceDataBalance,
  balanceDataBalanceError,
  actionsSection,
  walletsDataContainer,
  stepsForm,
  rows,
  swipeButton,
  confirmCheckWrapper,
  confirmRow,
  tabsWrapper,
};
